export const formatNumber = (num?: number) =>
  num !== undefined && num !== null ? num.toFixed(3).replace('.', ',') : ''
